import { useDispatch, useSelector } from "react-redux"
import ApplyOptions from "../components/admission/applyOptions"
import ApplySection from "../components/admission/applySection"
import ContactUs from "../components/admission/contactUs"
import Faq from "../components/admission/faq"
import ImportantDates from "../components/admission/importantDates"
import OurColleges from "../components/admission/ourColleges"
import ProfessionalAndExecutiveEducation from "../components/admission/professionalAndExecutiveEducation"
import ProgramChoice from "../components/admission/programChoice"
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/banner/banner"
import { useEffect } from "react"
import { fetchAdmissionData } from "../redux/slice/admissionPage"
import { retrunAssets } from "../utils/getAssets"

const Admission = () => {


    const state = useSelector(state => state.admission)
    const dispatch = useDispatch()

    useEffect(() => {
        if (state?.data == null) {
            dispatch(fetchAdmissionData("admission"))
        }
    }, [state, dispatch])


    const admission = state?.data?.properties


    const text = admission?.title
    const bg = admission?.backgroundImage != null ? retrunAssets(admission?.backgroundImage[0]?.url) : ""
    return (
        <AnimatedPage>
            <Banner text={text} bg={bg} />
            <ApplySection admission={admission} />
            <ApplyOptions admission={admission} />
            <ImportantDates admission={admission} />
            <ProgramChoice admission={admission} />
            <ProfessionalAndExecutiveEducation admission={admission} />
            <OurColleges />
            <Faq admission={admission}/>
            <ContactUs admission={admission}/>
        </AnimatedPage>
    )
}

export default Admission